import {makeForgotPasswordConfirmLegacy} from 'main/factories/usecases/public/remote-forgot-password/post-forgot-password-confirm-legacy-factory';
import {ForgotPasswordConfirmLegacyParams} from './types.js';

export async function forgotPasswordConfirmLegacy({
	signal,
	...confirmParams
}: ForgotPasswordConfirmLegacyParams) {
	const response = await makeForgotPasswordConfirmLegacy().forgotPasswordConfirmLegacy({
		signal,
		...confirmParams,
	});

	return response;
}
